import { useEffect } from 'react';
import PortalIdParser from 'PortalIdParser';
// @ts-expect-error Untyped module
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { useSelector } from 'react-redux';
import CopilotCollaborationContextProvider from 'tinymce-copilot/components/CopilotCollaborationContextProvider';
import { getContentAssistantContextAsStringForCopilot } from 'copilot-plugins/utils/contentAssistantUtils';
// @ts-expect-error Untyped selector
import bus from 'ContentEditorUI/coffee/lib/eventBus';
import { forwardCommandToCopilot } from 'tinymce-copilot/handleSlashOrHighlightCommand';
// @ts-expect-error Untyped selector
import { getHost } from '../redux/selectors/routingSelectors';
// @ts-expect-error Untyped selector
import { getCanUseCopilotCollaborationMinusContentAssistanceCheck } from 'ContentEditorUI/redux/selectors/featureSelectors';
import { getLanguage } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import useClearCopilotActiveEditorOnModuleChange from './useClearCopilotActiveEditorOnModuleChange';
import { jsx as _jsx } from "react/jsx-runtime";
const SETTINGS_PATH = `/settings/${PortalIdParser.get()}/ai-assistant`;
export function ContentEditorCopilotCollaborationContextProvider({
  children
}) {
  const canUseCopilotCollaboration = useSelector(getCanUseCopilotCollaborationMinusContentAssistanceCheck);
  const appKey = EditorConfigSingleton.get('appKey');
  const hostUrl = useSelector(getHost);
  const settingsLink = `${hostUrl}${SETTINGS_PATH}`;
  const contentLanguage = useSelector(getLanguage);

  // @ts-expect-error Use global to ensure we immediately get the contentId on first render
  const {
    contentId
  } = window.hubspot.parseEditorUrl();
  return /*#__PURE__*/_jsx(CopilotCollaborationContextProvider, {
    appKey: appKey,
    isCopilotCollaborationEnabled: canUseCopilotCollaboration,
    sessionId: contentId,
    hostUrl: hostUrl,
    settingsLink: settingsLink,
    contentLanguage: contentLanguage,
    customHandleTextReplacement: customHandleTextReplacement,
    useCustomCollaborationSessionLogic: useCustomCollaborationSessionLogic,
    children: children
  });
}

// Further custom editor logic that needs to use sendActionFromAppToCopilot and sendCollaborationStateChangeFromAppToCopilot
// from useCollaborationSession
function useCustomCollaborationSessionLogic(sendActionFromAppToCopilot, sendCollaborationStateChangeFromAppToCopilot, currentContextRef) {
  useClearCopilotActiveEditorOnModuleChange();
  useEffect(() => {
    bus.on('post:copilot:send-copilot-command', message => {
      const {
        command,
        editorContext,
        currentSelection,
        hasSelection,
        precedingText = '',
        followingText = '',
        brandVoiceOptions,
        contentLanguage
      } = message.payload;
      forwardCommandToCopilot(command, editorContext, hasSelection, currentSelection, precedingText, followingText, currentContextRef, sendActionFromAppToCopilot, brandVoiceOptions, contentLanguage);
    });
    bus.on('post:copilot:update-tiny-mce-state', message => {
      const {
        hasFocus,
        hasSelection,
        editorContext,
        currentSelection
      } = message.payload;

      // TODO, provide a way for consumers to provide a callback to tweak the context?
      const collaborationContext = getContentAssistantContextAsStringForCopilot({
        editorContext,
        selectedText: hasSelection ? currentSelection : ''
      });
      currentContextRef.current = collaborationContext;
      // Send the current state to Copilot
      sendCollaborationStateChangeFromAppToCopilot({
        hasFocus,
        hasSelection
      });
    });
    return () => {
      bus.off('post:copilot:send-copilot-command');
      bus.off('post:copilot:update-tiny-mce-state');
    };
  }, [currentContextRef, sendActionFromAppToCopilot, sendCollaborationStateChangeFromAppToCopilot]);
}
function customHandleTextReplacement(activeEditor, generatedText) {
  if (activeEditor) {
    // If there is an active editor in the parent frame, fall through to default behavior
    return false;
  }
  bus.postMessage({
    action: 'insertIntoRichText:inpage',
    payload: {
      text: generatedText
    }
  });
}